import AppCollapse from '@core/components/app-collapse/AppCollapse'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem'
import Vue from 'vue'

Vue.component('app-collapse', AppCollapse)
Vue.component('app-collapse-item', AppCollapseItem)
